import { render, staticRenderFns } from "./SolicitudInformacion.vue?vue&type=template&id=03d6c751&scoped=true&"
import script from "./SolicitudInformacion.vue?vue&type=script&lang=js&"
export * from "./SolicitudInformacion.vue?vue&type=script&lang=js&"
import style0 from "./SolicitudInformacion.vue?vue&type=style&index=0&id=03d6c751&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d6c751",
  null
  
)

export default component.exports